import { ROUTE_DOCS_PROJECTS } from '@/common/constants';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface TActions {
  regnum: string;
  isLoading?: boolean;
  idDeleteProject: string;
}

export const Actions: FC<TActions> = ({
  regnum,
  isLoading,
  idDeleteProject,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const onDelete = async ({ idDelete }: { idDelete: string }) => {
    try {
      navigate(ROUTE_DOCS_PROJECTS);
      setOpen(false);
    } catch (error) {
      console.error('Error creating document:', error);
    }
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-5">
        {!isLoading ? (
          <>
            <p className="text-lg font-semibold text-green-default">{regnum}</p>
            <div className="flex gap-2.5"></div>
          </>
        ) : (
          <div className="h-[28px] bg-gray-200 rounded animate-pulse w-32" />
        )}
      </div>

      <div className="flex items-center">
        {true && (
          <>
            <Dialog open={open} onOpenChange={setOpen}>
              {/* <DialogTrigger asChild>
                <Button
                  variant="outline"
                  className="rounded-[10px] p-2 border-red-default"
                >
                  <Trash2 className="stroke-red-default" />
                </Button>
              </DialogTrigger> */}
              <DialogContent className=" sm:max-w-[432px]">
                <DialogHeader>
                  <DialogTitle>{t('do.you.approve.action')}</DialogTitle>
                </DialogHeader>
                <div className="flex items-center gap-4">
                  <Button
                    type="button"
                    className="w-full"
                    variant="outline"
                    onClick={() => setOpen(false)}
                  >
                    {t('cancel')}
                  </Button>
                  <Button
                    type="button"
                    className="w-full"
                    variant="secondary"
                    onClick={() => onDelete({ idDelete: idDeleteProject })}
                  >
                    {t('confirmation')}
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
          </>
        )}
      </div>
    </div>
  );
};
